export type GroupsManagementFilterValue =
  (typeof GROUPS_MANAGEMENT_FILTER)[keyof typeof GROUPS_MANAGEMENT_FILTER];

export type GroupTypeValue = (typeof GROUP_TYPE)[keyof typeof GROUP_TYPE];

export interface GroupsManagementFilterOption {
  label: string;
  value: GroupsManagementFilterValue;
}

export const GROUPS_MANAGEMENT_FILTER = {
  ALL: 'all',
  LOCAL: 'local',
  SCIM: 'scim',
} as const;

export const GROUP_TYPE = {
  LOCAL: 'local',
  SCIM: 'scim',
} as const;

export const GROUP_TYPE_SUBTITLE: Record<GroupTypeValue, string> = {
  local: 'Managed in this application',
  scim: 'Managed by your organisation',
};

export const GROUPS_MANAGEMENT_FILTER_OPTIONS: GroupsManagementFilterOption[] = [
  { label: 'All', value: GROUPS_MANAGEMENT_FILTER.ALL },
  { label: GROUP_TYPE_SUBTITLE.local, value: GROUPS_MANAGEMENT_FILTER.LOCAL },
  { label: 'Managed by your Organisation', value: GROUPS_MANAGEMENT_FILTER.SCIM },
];
